// extracted by mini-css-extract-plugin
export default {"iframe-container":"HeaderVideo_iframe-container__65ciF"};